//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        label: {
            type: String,
            default: function () {
                return this.$lang.get('partials.button.finished');
            }
        },
        width: {
            type: Number,
            default: 240
        },
        x: {
            type: Number,
            default: 600
        },
        y: {
            type: Number,
            default: 760
        },
        showDelay: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'success'
        }
    }
};
